var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { staticClass: "main user-layout-register", style: _vm.mainStyle },
    [
      _c(
        "a-form",
        {
          ref: "formRegister",
          attrs: {
            autoFormCreate: (form) => {
              this.form = form
            },
            id: "formRegister",
          },
        },
        [
          _c(
            "a-form-item",
            {
              attrs: {
                fieldDecoratorId: "username",
                fieldDecoratorOptions: {
                  rules: [
                    { required: true, message: "用户名不能为空" },
                    { validator: this.handleUserName },
                  ],
                  validateTrigger: ["change", "blur"],
                  validateFirst: true,
                },
              },
            },
            [
              _c("a-input", {
                attrs: {
                  size: "large",
                  type: "text",
                  autocomplete: "false",
                  placeholder: "请输入用户名",
                },
              }),
            ],
            1
          ),
          _c(
            "a-popover",
            {
              attrs: {
                placement: "rightTop",
                trigger: "click",
                visible: _vm.state.passwordLevelChecked,
              },
            },
            [
              _c("template", { slot: "content" }, [
                _c(
                  "div",
                  { style: { width: "240px" } },
                  [
                    _c(
                      "div",
                      { class: ["user-register", _vm.passwordLevelClass] },
                      [
                        _vm._v("强度："),
                        _c("span", [_vm._v(_vm._s(_vm.passwordLevelName))]),
                      ]
                    ),
                    _c("a-progress", {
                      attrs: {
                        percent: _vm.state.percent,
                        showInfo: false,
                        strokeColor: _vm.passwordLevelColor,
                      },
                    }),
                    _c("div", { staticStyle: { "margin-top": "10px" } }, [
                      _c("span", [
                        _vm._v(
                          "请至少输入 6 个字符。请不要使用容易被猜到的密码。"
                        ),
                      ]),
                    ]),
                  ],
                  1
                ),
              ]),
              _c(
                "a-form-item",
                {
                  attrs: {
                    fieldDecoratorId: "password",
                    fieldDecoratorOptions: {
                      rules: [
                        { required: false },
                        { validator: this.handlePasswordLevel },
                      ],
                      validateTrigger: ["change", "blur"],
                      validateFirst: true,
                    },
                  },
                },
                [
                  _c("a-input-password", {
                    attrs: {
                      size: "large",
                      type: "password",
                      autocomplete: "false",
                      placeholder: "至少6位密码，区分大小写",
                    },
                    on: { click: _vm.handlePasswordInputClick },
                  }),
                ],
                1
              ),
            ],
            2
          ),
          _c(
            "a-form-item",
            {
              attrs: {
                fieldDecoratorId: "password2",
                fieldDecoratorOptions: {
                  rules: [
                    { required: true, message: "至少6位密码，区分大小写" },
                    { validator: this.handlePasswordCheck },
                  ],
                  validateTrigger: ["change", "blur"],
                  validateFirst: true,
                },
              },
            },
            [
              _c("a-input-password", {
                attrs: {
                  size: "large",
                  type: "password",
                  autocomplete: "false",
                  placeholder: "确认密码",
                },
              }),
            ],
            1
          ),
          _vm.checkcodeFlag === "1"
            ? _c(
                "a-row",
                { attrs: { gutter: 0 } },
                [
                  _c(
                    "a-col",
                    { attrs: { span: 14 } },
                    [
                      _c(
                        "a-form-item",
                        {
                          attrs: {
                            fieldDecoratorId: "inputCode",
                            fieldDecoratorOptions: {
                              rules: [
                                { required: true, message: "验证码不能为空" },
                                { validator: this.handleInputCode },
                              ],
                              validateTrigger: ["change", "blur"],
                              validateFirst: true,
                            },
                          },
                        },
                        [
                          _c(
                            "a-input",
                            {
                              attrs: {
                                size: "large",
                                type: "text",
                                "default-value": "",
                                placeholder: "请输入验证码",
                              },
                            },
                            [
                              _c("a-icon", {
                                style: { color: "rgba(0,0,0,.25)" },
                                attrs: { slot: "prefix", type: "smile" },
                                slot: "prefix",
                              }),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                  _c(
                    "a-col",
                    {
                      staticStyle: { "text-align": "right" },
                      attrs: { span: 10 },
                    },
                    [
                      _vm.requestCodeSuccess
                        ? _c("img", {
                            staticStyle: { "margin-top": "2px" },
                            attrs: { src: _vm.randCodeImage },
                            on: { click: _vm.handleChangeCheckCode },
                          })
                        : _c("img", {
                            staticStyle: { "margin-top": "2px" },
                            attrs: {
                              src: require("../../assets/checkcode.png"),
                            },
                            on: { click: _vm.handleChangeCheckCode },
                          }),
                    ]
                  ),
                ],
                1
              )
            : _vm._e(),
          _c(
            "a-form-item",
            { style: _vm.btnStyle },
            [
              _c(
                "a-button",
                {
                  staticClass: "register-button",
                  attrs: {
                    size: "large",
                    type: "primary",
                    htmlType: "submit",
                    loading: _vm.registerBtn,
                    disabled: _vm.registerBtn,
                  },
                  on: {
                    click: function ($event) {
                      $event.stopPropagation()
                      $event.preventDefault()
                      return _vm.handleSubmit.apply(null, arguments)
                    },
                  },
                },
                [_vm._v("注册租户\n      ")]
              ),
              _c(
                "router-link",
                { staticClass: "login", attrs: { to: { name: "login" } } },
                [_vm._v("使用已有租户登录")]
              ),
            ],
            1
          ),
          _vm.device === "mobile"
            ? _c(
                "div",
                { staticClass: "login-copyright" },
                [
                  _c(
                    "a-row",
                    [
                      _c("a-col", [
                        _vm._v(
                          "\n          © 2015-2030 Powered By\n          "
                        ),
                        _c(
                          "a",
                          {
                            staticStyle: { color: "#00458a" },
                            attrs: { href: _vm.systemUrl, target: "_blank" },
                          },
                          [_vm._v("官方网站")]
                        ),
                      ]),
                    ],
                    1
                  ),
                ],
                1
              )
            : _vm._e(),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }